import { useCallback, useEffect, useState } from 'react';

export interface ViewState {
	longitude: number;
	latitude: number;
	zoom: number;
	pitch: number;
	bearing: number;
}

export interface SelectedMap {
	latitude?: number;
	longitude?: number;
	zoomLevel?: number;
}

export interface IncomingViewState {
	longitude?: number;
	latitude?: number;
	zoom?: number;
	pitch?: number;
	bearing?: number;
}

const longitude = Number(import.meta.env.VITE_MAP_INIT_LONGITUDE) || -122.45;
const latitude = Number(import.meta.env.VITE_MAP_INIT_LATITUDE) || 37.78;

const initialViewState: ViewState = {
	longitude,
	latitude,
	zoom: 11.5,
	pitch: 0,
	bearing: 0,
};

export function useMapViewState(selectedMap: SelectedMap | null | undefined) {
	const [viewState, setViewState] = useState<ViewState>(() => {
		if (selectedMap?.latitude && selectedMap?.longitude) {
			return {
				longitude: selectedMap.longitude,
				latitude: selectedMap.latitude,
				zoom: selectedMap.zoomLevel!,
				pitch: 0,
				bearing: 0,
			};
		}
		return initialViewState;
	});

	useEffect(() => {
		if (selectedMap?.latitude && selectedMap?.longitude) {
			setViewState({
				longitude: selectedMap.longitude,
				latitude: selectedMap.latitude,
				zoom: selectedMap.zoomLevel!,
				pitch: 0,
				bearing: 0,
			});
		}
	}, [selectedMap?.latitude, selectedMap?.longitude, selectedMap?.zoomLevel]);

	const applyViewStateChange = useCallback((nextViewState: IncomingViewState) => {
		if (nextViewState.longitude !== undefined && nextViewState.latitude !== undefined) {
			setViewState({
				longitude: nextViewState.longitude,
				latitude: nextViewState.latitude,
				zoom: nextViewState.zoom!,
				pitch: nextViewState.pitch || 0,
				bearing: nextViewState.bearing || 0,
			});
		}
	}, []);

	return { viewState, setViewState, applyViewStateChange };
}
